import React from "react";
import Img from "gatsby-image";
import styles from "./sponsors.module.css";

export default ({ data }) => {
  const teams = ["Calebrators", "GIO", "Walter's wave"];
  
  // Combine logos and teams into a single array with type property
  const allItems = [
    ...data[0].node.logos.map(logo => ({ type: 'logo', data: logo, name: logo.title })),
    ...teams.map(team => ({ type: 'team', data: team, name: team }))
  ];
  
  // Sort all items alphabetically by name
  const sortedItems = allItems.sort((a, b) => a.name.localeCompare(b.name));
  
  return (
    <div>
      <div className="text-center mt-4">
        <h4 className={styles.headline}>
          We are proud to have partners and 
          <br />
          teams that support this event year in year out.
        </h4>
      </div>

      <div className="row justify-content-center">
        <div className="col-md-9">
          <div className="row justify-content-center">
            {sortedItems.map(item => {
              if (item.type === 'logo') {
                return (
                  <div
                    className={`col-md-1 col-sm-6 ${styles.image}`}
                    key={item.name}
                  >
                    <Img alt="" sizes={item.data.sizes} />
                  </div>
                )
              } else {
                return (
                  <div
                    className={`col-md-1 col-sm-6 ${styles.image}`}
                    key={item.name}
                    style={{display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100px'}}
                  >
                    <div style={{fontSize: '16px', fontWeight: '500', textAlign: 'center'}}>{item.name}</div>
                  </div>
                )
              }
            })}
          </div>
        </div>
      </div>
    </div>
  )
}
